import { MediaType } from "@shared/models/media";

export const getMediaTypeByFileType = (fileType: string): MediaType => {
  if (fileType.startsWith("video")) {
    return MediaType.Video;
  }
  return fileType.startsWith("image") ? MediaType.Image : MediaType.File;
};
